import Decimal from 'decimal.js';
const isDateTimeEmpty = function (timeString) {
    return timeString === null || !timeString;
};

export const numberToFixed = function (number, fractional) {
    return parseFloat(parseFloat(number).toFixed(fractional));
};

export const formatDateTimeString = function (timeString) {
    if (isDateTimeEmpty(timeString)) {
        return '';
    }
    // "2019-01-18T18:30:15.236"
    let parts = timeString.split('T');
    if (parts.length !== 2) {
        return '-';
    }

    let ymd = parts[0];
    let hms = parts[1];
    if (hms.split('.').length === 2) {
        hms = hms.split('.')[0];
    }

    return `${ymd} ${hms}`;
};

export const arrayUnique = function (array) {
    let res = [];
    for (let i = 0, len = array.length; i < len; i++) {
        let current = array[i];
        if (res.indexOf(current) === -1) {
            res.push(current);
        }
    }
    return res;
};
export const getNumberThousandString=function(num,delfaultValue=''){
     if(num){
       let numTwoDigit =num.toFixed(2);
       return  parseFloat(numTwoDigit).toLocaleString("en", { minimumFractionDigits: 2 });
     }else{
      
        return delfaultValue;
     }
};

//转换成小数位数向下取整，dig小数位数
export const getNumberFloorDecimal=function(num,dig=2){
    if(isNaN(num)){
        return 0.00;
    }
    let decimalNumber = new Decimal(num);
    // 保留两位小数并向下取整
    return decimalNumber.toDecimalPlaces(dig, Decimal.ROUND_FLOOR).toNumber();
};

//减法运算
export const numberSubtraction=function(num1,num2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }
    num1=new Decimal(num1);
    num2=new Decimal(num2);
    // 保留两位小数并向下取整
    return num1.sub(num2).toNumber();
};


export const getTodayDateString = function () {
    let now = new Date();
    let month = '' + (now.getMonth() + 1);
    let day = '' + now.getDate();
    let year = '' + now.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
};



export const getDateString = function () {
    let now = new Date();
    let month = '' + (now.getMonth() + 1);
    let day = '' + now.getDate();
    let year = '' + now.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return `${year}年${month}月${day}日`
};



// WEBPACK FOOTER //
// ./src/libs/utils.js